import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  globalOrderFrom: [],
  globalOrderFromReport: [],
  globalDepotName: [],
  globalDAStatus:[],
  globalDA:[],
  globalTripStatus:[],
  globalTrip:[],
  globalOrderStatus:[],
  globalDeliveryType: [],
  globalCustomerReport: [],
  globalIsGetDetail:false,
  globalDeliveryAssociateStatusReport: [],
  globalDeliveryAssociate: []
}

const globalMSSSlices = createSlice({
  name: 'globalMSS',
  initialState: initialState,
  reducers: {
    setGlobalOrderFrom: (state, action) => {
      state.globalOrderFrom = action.payload
    },
    setGlobalDepotName: (state, action) => {
      state.globalDepotName = action.payload
    },
    setGlobalOrderFromReport: (state,action) => {
      state.globalOrderFromReport = action.payload
    },
    setGlobalDAStatus: (state, action) => {
      state.globalDAStatus = action.payload
    },
    setGlobalDA: (state, action) => {
      state.globalDA = action.payload
    },
    setGlobalTripStatus: (state, action) => {
      state.globalTripStatus = action.payload
    },
    setGlobalTrip: (state, action) => {
      state.globalTrip = action.payload
    },
    setGlobalOrderStatus: (state, action) => {
      state.globalOrderStatus = action.payload
    },
    setGlobalIsGetDetail: (state, action) => {
      state.globalIsGetDetail= action.payload
    },
    setGlobalDeliveryType: (state, action) => {
      state.globalDeliveryType = action.payload
    },
    setGlobalCustomerReport: (state, action) => {
      state.globalCustomerReport = action.payload
    },
    setGlobalDeliveryAssociateStatusReport: (state, action) => {
      state.globalDeliveryAssociateStatusReport = action.payload
    },
    setGlobalDeliveryAssociate: (state, action) => {
      state.globalDeliveryAssociate = action.payload
    }
  }
});

export const { 
  setGlobalOrderFrom, 
  setGlobalDepotName, 
  setGlobalOrderFromReport, 
  setGlobalDAStatus, 
  setGlobalDA, 
  setGlobalOrderStatus, 
  setGlobalTrip, 
  setGlobalTripStatus, 
  setGlobalDeliveryType,
  setGlobalCustomerReport,
  setGlobalIsGetDetail,
  setGlobalDeliveryAssociateStatusReport,
  setGlobalDeliveryAssociate
} = globalMSSSlices.actions;

export default globalMSSSlices.reducer;